module.exports = __webpack_public_path__ + "static/media/4.b4fa1f0f.jpg";